import React from "react";
import { Box, CircularProgress } from "@mui/material";

const ContentLoading: React.FC = () => {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <CircularProgress />
    </Box>
  );
};

export default ContentLoading;